import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Menu } from '../../models/menu/menu';
import { PageService } from '../../models/page.service';
import { MenuService } from './menu.service';
import { LogService } from '../../service/log.service';
var MenuComponent = /** @class */ (function () {
    function MenuComponent(logger, page, service) {
        this.logger = logger;
        this.page = page;
        this.service = service;
    }
    MenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.page.meta().subscribe(function (meta) {
            if (meta.menus) {
                _this.current = _this.service.getMenuOpenState('menu-current');
                _this.menus = meta.menus;
                _this.logger.debug('menu:', _this.menus);
            }
        });
        this.changeSubscription = this.service.changeObservable.subscribe(function () {
            _this.current = _this.service.getMenuOpenState('menu-current');
        });
    };
    MenuComponent.prototype.trackByMenu = function (index, menu) {
        return menu.id;
    };
    MenuComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    MenuComponent.decorators = [
        { type: Component, args: [{
                    selector: '[pa-menu]',
                    moduleId: module.id.toString(),
                    template: "<ul class=\"gNav_accWrapperUl\">\n  <li *ngFor=\"let menu of menus; trackBy: trackByMenu\">\n    <menugroup [menu]=\"menu\" [current]=\"current\"></menugroup>\n  </li>\n</ul>\n"
                }] }
    ];
    /** @nocollapse */
    MenuComponent.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: PageService },
        { type: MenuService }
    ]; };
    return MenuComponent;
}());
export { MenuComponent };
var MenuGroupComponent = /** @class */ (function () {
    function MenuGroupComponent(logger, page, service, logService) {
        this.logger = logger;
        this.page = page;
        this.service = service;
        this.logService = logService;
        this.url = '';
        this.open = false;
    }
    MenuGroupComponent.prototype.ngOnInit = function () {
        this.logger.debug('menu:', this.menu);
        this.url = this.service.url(this.menu);
        this.open = this.service.getMenuOpenState('menu-' + this.menu.id);
    };
    MenuGroupComponent.prototype.onChange = function (id) {
        this.service.setMenuOpenState('menu-' + id, this.open);
    };
    MenuGroupComponent.prototype.onClickAnc = function (menu) {
        this.service.setMenu(menu.id, this.service.url(menu));
        if (window.innerWidth <= 575) {
            $('#showLeftPush').removeClass('active');
            $('#menuPush').addClass('pushMenuWrapper-toleft');
            $('#menu-s1').addClass('menu-close');
            this.service.setMenuOpenState('menu-showLeftPush', false);
        }
        this.logService.setLog('menuClick');
    };
    MenuGroupComponent.prototype.trackByMenu = function (index, menu) {
        return menu.id;
    };
    MenuGroupComponent.decorators = [
        { type: Component, args: [{
                    selector: 'menugroup',
                    moduleId: module.id.toString(),
                    template: "<ng-template [ngIf]=\"!menu.children\" [ngIfElse]=\"elseBlock\">\n  <a class=\"gNav_accAnchor\" [class.gNav_accAnchor-current]=\"current === menu.id\" [routerLink]=\"[url]\" (click)=\"onClickAnc(menu)\">{{ menu.title }}</a>\n</ng-template>\n<ng-template #elseBlock>\n  <input class=\"gNav_accInput\" type=\"checkbox\" name =\"menu-{{ menu.id }}\" id=\"menu-{{ menu.id }}\" [(ngModel)]=\"open\" (change)=\"onChange(menu.id)\">\n  <label class=\"gNav_accLabel\" for=\"menu-{{ menu.id }}\">{{ menu.title }}</label>\n  <ul class=\"gNav_accSubmenuUl\">\n    <li *ngFor=\"let mn of menu.children; trackBy: trackByMenu\">\n      <menugroup [menu]=\"mn\" [current]=\"current\"></menugroup>\n    </li>\n  </ul>\n</ng-template>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    MenuGroupComponent.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: PageService },
        { type: MenuService },
        { type: LogService }
    ]; };
    MenuGroupComponent.propDecorators = {
        menu: [{ type: Input }],
        current: [{ type: Input }]
    };
    return MenuGroupComponent;
}());
export { MenuGroupComponent };
//# sourceMappingURL=menu.component.js.map